<template>
	<router-view>

	</router-view>

    <Notivue v-slot="item">
        <Notification :theme="pastelTheme"  :item="item" >
            <NotificationProgress :item="item" />
        </Notification>
    </Notivue>
    <div class="row">
        <div class="col-12 text-center">
			<span class="spinner spinner-border spinner-card flex-shrink-0" id="spinner" role="status"
                  style="height: 5rem; width: 5rem; display: none">
				<span class="visually-hidden"></span>
			</span>
        </div>
    </div>
</template>
<script setup>
import store from '@/state/store'
import { Notivue, Notification,  pastelTheme, NotificationProgress } from 'notivue';

window.addEventListener('storage', (event) => {

    if (event.key === 'currentUser') {
        const newStoreState = JSON.parse(event.newValue);

        store.commit('auth/setCurrentUser', newStoreState)

        localStorage.removeItem('currentUser');
    }
});

</script>
